
import { Observable } from "rxjs";
import { AzureStorageContainer } from "./types.domain";

export interface BoundingBoxData {
    BoundingBox: {
        Height: number,
        Left: number,
        Top: number,
        Width: number,
    },
    Confidence: number,
}

export interface FaceMatchData {
    Face: BoundingBoxData,
    Similarity: number,
}

export interface IdentityVerificationResult {
    id: number,
    individualId: string,
    livenessConfidence: number,
    livenessPicture: string,
    passLivenessTest: boolean,
    faceCompareScore: number,
    passFaceCompare: boolean,
    livenessPictureBoundingBox: BoundingBoxData,
    driverLicenceBoundingBox: FaceMatchData[],
    driverLicenceFile: string,
    identityVerificationTime: string,
    faceCompareCounter: number,
    lastUpdatedBy: number | null,
    lastUpdatedTime: string,
    lastUpdatedGivenName: string | null,
    lastUpdatedFamilyName: string | null,
}

export type DownloadDocumentFromAzureFn = (file: string, container?: AzureStorageContainer) => Observable<{type: "Buffer"; data: Buffer}>;
